"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTemplateReplaceMap = getTemplateReplaceMap;
const tslib_1 = require("tslib");
const os_1 = tslib_1.__importDefault(require("os"));
const featureFlags_1 = require("../../../common/featureFlags");
const stringUtils_1 = require("../../../common/stringUtils");
const crypto_1 = require("../../../core/crypto");
const constants_1 = require("../../../question/constants");
function getTemplateReplaceMap(inputs) {
    const appName = inputs[constants_1.QuestionNames.AppName];
    const safeProjectName = inputs[constants_1.QuestionNames.SafeProjectName] ?? (0, stringUtils_1.convertToAlphanumericOnly)(appName);
    const solutionName = inputs[constants_1.QuestionNames.SolutionName] ?? appName;
    const targetFramework = inputs.targetFramework;
    const placeProjectFileInSolutionDir = inputs.placeProjectFileInSolutionDir === "true";
    const llmService = inputs[constants_1.QuestionNames.LLMService];
    let openAIKey = inputs[constants_1.QuestionNames.OpenAIKey];
    let azureOpenAIKey = inputs[constants_1.QuestionNames.AzureOpenAIKey];
    let azureAISearchApiKey = inputs[constants_1.QuestionNames.AzureAISearchApiKey];
    const azureOpenAIEndpoint = inputs[constants_1.QuestionNames.AzureOpenAIEndpoint];
    const azureOpenAIDeploymentName = inputs[constants_1.QuestionNames.AzureOpenAIDeploymentName];
    const azureAISearchEndpoint = inputs[constants_1.QuestionNames.AzureAISearchEndpoint];
    const openAIEmbeddingModel = inputs[constants_1.QuestionNames.OpenAIEmbeddingModel];
    const azureOpenAIEmbeddingDeploymentName = inputs[constants_1.QuestionNames.AzureOpenAIEmbeddingDeploymentName];
    const gcName = inputs[constants_1.QuestionNames.GCName];
    const gcConnectionId = inputs[constants_1.QuestionNames.GCConnectionId];
    const foundryEndpoint = inputs[constants_1.QuestionNames.FoundryEndpoint];
    const foundryAgentId = inputs[constants_1.QuestionNames.FoundryAgentId];
    if (inputs.projectId !== undefined && (openAIKey || azureOpenAIKey)) {
        const cryptoProvider = new crypto_1.LocalCrypto(inputs.projectId);
        if (openAIKey) {
            const result = cryptoProvider.encrypt(openAIKey);
            openAIKey = result.value;
        }
        if (azureOpenAIKey) {
            const result = cryptoProvider.encrypt(azureOpenAIKey);
            azureOpenAIKey = result.value;
        }
        if (azureAISearchApiKey) {
            const result = cryptoProvider.encrypt(azureAISearchApiKey);
            azureAISearchApiKey = result.value;
        }
    }
    return {
        appName: appName,
        ProjectName: appName,
        SolutionName: solutionName,
        TargetFramework: targetFramework ?? "net8.0",
        PlaceProjectFileInSolutionDir: placeProjectFileInSolutionDir ? "true" : "",
        SafeProjectName: safeProjectName,
        SafeProjectNameLowerCase: safeProjectName.toLocaleLowerCase(),
        useOpenAI: llmService === "llm-service-openai" ? "true" : "",
        useAzureOpenAI: llmService === "llm-service-azure-openai" ? "true" : "",
        openAIKey: openAIKey ?? "",
        originalOpenAIKey: inputs[constants_1.QuestionNames.OpenAIKey] ?? "",
        azureOpenAIKey: azureOpenAIKey ?? "",
        originalAzureOpenAIKey: inputs[constants_1.QuestionNames.AzureOpenAIKey] ?? "",
        azureAISearchApiKey: azureAISearchApiKey ?? "",
        originalAzureAISearchApiKey: inputs[constants_1.QuestionNames.AzureAISearchApiKey] ?? "",
        azureOpenAIEndpoint: azureOpenAIEndpoint ?? "",
        azureOpenAIDeploymentName: azureOpenAIDeploymentName ?? "",
        azureOpenAIEmbeddingDeploymentName: azureOpenAIEmbeddingDeploymentName ?? "",
        azureAISearchEndpoint: azureAISearchEndpoint ?? "",
        gcName: gcName ?? "",
        gcConnectionId: gcConnectionId ?? "",
        FoundryEndpoint: foundryEndpoint ?? "",
        FoundryAgentId: foundryAgentId ?? "",
        openAIEmbeddingModel: openAIEmbeddingModel ?? "",
        NewProjectTypeName: process.env.TEAMSFX_NEW_PROJECT_TYPE_NAME ?? "M365Agent",
        NewProjectTypeExt: process.env.TEAMSFX_NEW_PROJECT_TYPE_EXTENSION ?? "atkproj",
        CEAEnabled: featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.CEAEnabled) ? "true" : "",
        SensitivityLabelEnabled: featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.SensitivityLabelEnabled)
            ? "true"
            : "",
        SandBoxedTeam: featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.SandBoxedTeam) ? "true" : "",
        pathDelimiter: os_1.default.platform() === "win32" ? ";" : ":",
    };
}
//# sourceMappingURL=templateReplaceMap.js.map